import { memo } from 'react'

import { useTranslation } from 'react-i18next'

import HTML from 'common/components/html'
import LostInSpace from 'common/components/lostInSpace'

const AccessDenied = () => {
  const { t } = useTranslation()

  return (
    <LostInSpace>
      <div className="title">{t('access_denied.title')}</div>
      <div className="error">
        <HTML>{t('access_denied.message')}</HTML>
      </div>
    </LostInSpace>
  )
}

export default memo(AccessDenied)
